import { FC } from "react";
import { Table } from "taltech-styleguide";
import { creationTypeMapper, MinMaxComponent } from "./ReviewConfiguration";

type Props = {
  rowFirst: any;
  corridor: any;
  rowSecond: any;
};

const RoomItem: FC<any> = ({ index, isRowFirst, ...room }) => (
  <tr>
    <td>
      {room.label === undefined
        ? `R ${isRowFirst ? "1" : "2"}.${index+1}`
        : room.label}
    </td>
    <td>
      {creationTypeMapper.get(room.length.creationType) === "Random" ? (
        <>
          <b className="me-1">Min:</b>
          {room.length.options.min}m,
          <b className="ms-2 me-1">Max:</b>
          {room.length.options.max}m
        </>
      ) : (
        `${room.length.value}m`
      )}
    </td>
    <td>{room.isVariableLength ? "Yes" : "No"}</td>
  </tr>
);

export const LayoutReview: FC<Props> = ({ rowFirst, corridor, rowSecond }) => (
  <>
    <p>
      <b className="me-2">Row 1:</b>
      <div className="ps-3">
        <p className="mb-0">
          <b className="me-2">Width:</b>
          {rowFirst.width}
        </p>
        <p className="mb-0">
          <b className="me-2">Rooms No:</b>
          {rowFirst.numberOfRooms}
        </p>
        <div className="overflow-auto">
          <Table>
            <thead>
              <tr>
                <th>Room Name</th>
                <th>Room Length</th>
                <th>Variable Length</th>
              </tr>
            </thead>
            <tbody>
              {rowFirst.rooms.map((room: any, index: number) => (
                <RoomItem key={room.id} {...room} index={index} isRowFirst={true} />
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </p>
    <p className="mb-2">
      <b className="me-2">Corridor:</b>
      {corridor.width}m
    </p>
    <p>
      <b className="me-2">Row 2:</b>
      <div className="ps-3">
        <p className="mb-0">
          <b className="me-2">Width:</b>
          {rowSecond.width}
        </p>
        <p className="mb-0">
          <b className="me-2">Rooms No:</b>
          {rowSecond.numberOfRooms}
        </p>
        <div className="overflow-auto">
          <Table>
            <thead>
              <tr>
                <th>Room Name</th>
                <th>Room Length</th>
                <th>Variable Length</th>
              </tr>
            </thead>
            <tbody>
              {rowSecond.rooms.map((room: any, index: number) => (
                <RoomItem key={room.id} {...room} index={index} isRowFirst={false} />
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </p>
  </>
);
